import {css} from 'lit'; export default css`*,:after,:before{box-sizing:border-box}.sds-date-picker-item-inner{display:flex;flex-direction:column;gap:4px}.sds-date-picker-item-inner .sds-date-picker-item-inner__desc{font-size:1.1rem}`;
    